import React, { useContext, useEffect, useState } from 'react'
import { Button, Switch } from 'antd'
import openNotification from 'utils/Notification'
// import './index.css'
import { GET_BROKER_MAPPING_MODAL_SETTING } from '../graphql/Queries'
import client from 'apollo'
import { UPDATE_BROKER_MODAL_SETTING } from '../graphql/Mutations'
import Loader from 'components/loaders/Loader'
import CustomMeta from 'components/CustomMeta'
import { AppContext } from 'AppContext'
import { canUserEdit, canUserSave } from 'utils/User'

export default function BrokerModalSetting() {
  const { state: { currentUser, userPermissions, isClient } = {} } =
    useContext(AppContext) || {}
  const canSubmit =
    canUserEdit(userPermissions || currentUser, isClient) &&
    canUserSave(userPermissions || currentUser, isClient)

  const [showModalSetting, setShowModalSetting] = useState()
  const [loading, setLoading] = useState(false)
  const [updateLoading, setUpdateLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    client
      .query({
        query: GET_BROKER_MAPPING_MODAL_SETTING,
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        setLoading(false)
        setShowModalSetting(res?.data?.getModalSetting?.AllClient)
      })
      .catch((err) => {
        setLoading(false)
        console.error(err)
      })
  }, [])

  const updateData = () => {
    if (!canSubmit) return
    setUpdateLoading(true)
    client
      .mutate({
        mutation: UPDATE_BROKER_MODAL_SETTING,
        variables: {
          data: {
            toShowAllClient: showModalSetting,
          },
        },
      })
      .then((res) => {
        setUpdateLoading(false)
        openNotification('success', 'Setting updated successfully')
      })
      .catch((err) => {
        console.log(err)
        setUpdateLoading(false)
        openNotification('error', 'An error occurred! Please try again')
      })
  }

  if (loading) return <Loader />
  return (
    <>
      <CustomMeta title='Broker Modal Setting' />
      <div className='main_dashboard_div'>
        <div className='slot_booking_header'>
          <div className='slot_booking_header_title'>
            Broker Mapping Modal Setting
          </div>
        </div>
        <Switch
          disabled={!canSubmit}
          checked={showModalSetting}
          onChange={(e) => {
            setShowModalSetting(e)
          }}
        />
        <div
          style={{
            marginTop: '20px',
          }}
        >
          <Button
            type='primary'
            htmlType='submit'
            loading={updateLoading}
            onClick={updateData}
            disabled={!canSubmit}
          >
            Save
          </Button>
        </div>
      </div>
    </>
  )
}
